module.exports = __webpack_public_path__ + "img/header.d3c14758.jpg";